// src/pages/MembershipDetails.js
import React, { useEffect, useState } from "react";
import { getJson } from "../network/api";
import { ApiEndpoints } from "../network/config";
import "../styles/MembershipDetails.css";
import { Link } from "react-router-dom";

const MembershipDetails = () => {
  const userId = sessionStorage.getItem("userId");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [membership, setMembership] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (!userId) {
        setError("User not logged in.");
        setLoading(false);
        return;
      }

      setLoading(true);
      setError("");

      try {
        // GET /api/app/getMembershipDetails/{userId}
        const res = await getJson(`${ApiEndpoints.getMembershipDetails}/${userId}`);
        // API returns { data: { ... } }
        const data = (res && res.data) || null;
        setMembership(data);
      } catch (err) {
        console.error("Membership API error:", err);
        // try extract a useful message
        let msg = "Failed to load membership details.";
        try {
          if (err?.body) {
            const parsed = JSON.parse(err.body);
            msg = parsed?.message || parsed?.error?.message || msg;
          } else if (err?.message) {
            msg = err.message;
          }
        } catch (e) {}
        setError(msg);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [userId]);

  const display = (v) => {
    if (v === null || v === undefined || v === "") return "—";
    return v;
  };

  if (loading) {
    return (
      <div className="membership-container">
        <h1 className="membership-title">Membership Details</h1>
        <p style={{ textAlign: "center", marginTop: 30 }}>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="membership-container">
        <h1 className="membership-title">Membership Details</h1>
        <p style={{ color: "red", textAlign: "center", marginTop: 20 }}>{error}</p>
      </div>
    );
  }

  const m = membership || {};

  // Map API fields (based on sample)
  const planName = m.planName || m.plan_name || m.plan || "—";
  const price = m.amount ?? m.price ?? m.planAmount ?? null;
  const expiryDate = m.expiryDate || m.expiresOn || m.valid_to || null;
  const remainingDays = m.remainingDays ?? m.remaining_days ?? null;
  const profilesAllowed = m.totalProfilesAllowed ?? m.total_profiles_allowed ?? m.profilesAllowed ?? null;
  const profilesSelected = m.totalProfilesSelected ?? m.total_profiles_selected ?? m.profilesSelected ?? null;

  const formatPrice = (p) => {
    if (p === null || p === undefined || p === "") return "—";
    // if float, drop .0
    const num = typeof p === "number" ? (Number.isInteger(p) ? p : Math.round(p)) : p;
    return `₹${num}`;
  };

  const formatValidity = (days, expires) => {
    const daysPart = days !== null && days !== undefined ? `${days} days` : null;
    const expiresPart = expires ? `Expires on ${expires}` : null;

    if (daysPart && expiresPart) return `${daysPart} (${expiresPart})`;
    if (daysPart) return daysPart;
    if (expiresPart) return expiresPart;
    return "—";
  };

  return (
    <div className="membership-container">
      <h1 className="membership-title">Membership Details</h1>
      <p className="membership-subtitle">
        Manage your plan, check remaining profile access, and renew or Upgrade/Degrade.
      </p>

      <div className="membership-card">
        <div className="membership-row">
          <span className="membership-label">Plan Name:</span>
          <span className="membership-value">{display(planName)}</span>
        </div>

        <div className="membership-row">
          <span className="membership-label">Price:</span>
          <span className="membership-value">{price ? formatPrice(price) : display(price)}</span>
        </div>

        <div className="membership-row">
          <span className="membership-label">Validity:</span>
          <span className="membership-value">{formatValidity(remainingDays, expiryDate)}</span>
        </div>

        <div className="membership-row">
          <span className="membership-label">Profiles Allowed:</span>
          <span className="membership-value">{profilesAllowed !== null ? Math.round(profilesAllowed) : "—"}</span>
        </div>

        <div className="membership-row">
          <span className="membership-label">Profiles Selected:</span>
          <span className="membership-value">{profilesSelected !== null ? Math.round(profilesSelected) : "—"}</span>
        </div>
      </div>

      {/*
        Button section commented out as requested.
        <div className="button-container" style={{ marginTop: 18 }}>
          <Link to="/membership-list" style={{ textDecoration: "none" }}>
            <button className="upgrade-button">Upgrade Plan</button>
          </Link>
        </div>
      */}
    </div>
  );
};

export default MembershipDetails;
